<template>
  <v-card flat>
    <v-card-title><h2>{{ $t('heading') }}</h2></v-card-title>
    <v-card-text>
      <p>{{ $t('body') }}</p>
      <v-checkbox
        :label="$t('acceptGdpr')"
        :loading="isLoading"
        :disabled="isLoading"
        v-model="acceptedGdpr"/>
      <v-alert
        :value="acceptedGdpr"
        type="success">{{ $t('validGdpr', accepted) }}</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GdprSettings',
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    accepted () {
      if (this.getUser.accepted_dpp) {
        const date = this.$moment(this.getUser.accepted_dpp, 'YYYY-MM-DD hh:mm:ss')
        return {
          date: date.format('DD.MM.YYYY'),
          time: date.format('hh:mm')
        }
      }
    },
    acceptedGdpr: {
      get () {
        return Boolean(this.getUser.accepted_dpp)
      },
      async set (value) {
        this.isLoading = true
        await this.updateGdpr(value)
        this.isLoading = false
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateGdpr'])
  },
  i18n: {
    messages: {
      en: {
        acceptGdpr: 'Accept agreement',
        body: 'On 25 May 2018, the new regulation on the processing of personal data by private companies and public bodies will come into force. If your registered office is within the EU or you have customers from the EU, you must conclude an order processing agreement with us by the deadline.',
        heading: 'General data protection policy',
        validGdpr: 'You have concluded a valid order processing agreement with us on {date} at {time} o\'clock.'
      },
      tr: {
        acceptGdpr: 'Anlaşmayı kabul et',
        body: '25 Mayıs 2018 tarihinde, kişisel verilerin işlenmesi hakkındaki yeni düzenlemeler özel kuruluşlar ve devlet kuruluşları tarafından devreye girecektir. Kayıtlı ofisiniz AB içerisindeyse ya da AB\'de bulunan müşterileriniz varsa, bitiş tarihine kadar bizimle sipariş işlenmesi anlaşması yapmanız gerekmektedir.',
        heading: 'Genel bilgiler korunumu politikası',
        validGdpr: '{date} {time} tarih ve saatinde bizimle geçerli bir sipariş işlenme anlaşması yaptınız.'
      },
      de: {
        acceptGdpr: 'Vereinbarung akzeptieren',
        body: 'Am 25. Mai 2018 tritt die neue Verordnung zur Verarbeitung personenbezogener Daten durch private Unternehmen und öffentliche Stellen in Kraft. Wenn Ihr Firmensitz innerhalb der EU liegt oder sie Kunden aus der EU haben, müssen Sie bis zum Stichtag eine Vereinbarung zur Auftragsverarbeitung mit uns abschließen.',
        heading: 'EU-Richtlinien zum Datenschutz (DSGVO)',
        validGdpr: 'Sie haben mit uns am {date} um {time} Uhr eine gültige Vereinbarung zur Auftragsverarbeitung abgeschlossen.'
      },
      ru: {
        acceptGdpr: 'Принять соглашение',
        body: '25 мая 2018 года вступило в силу новое положение о обработке персональных данных частными компаниями и государственными органами. Если ваш зарегистрированный офис находится в ЕС или у вас есть клиенты из ЕС, вы должны заключить с нами договор обработки заказов.',
        heading: 'Общая политика защиты данных',
        validGdpr: 'Вы заключили с нами действующее соглашение о обработки заказов на {date} в {time}.'
      }
    }
  }
}
</script>
